import NftLogo from '../../src/legacy/NftLogo.tsx';
export default NftLogo;
